import { useState } from "react";

import { RoleHeaderModel } from "@/Administration/Models/Role/RoleHeaderModel";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";

import styles from "./RoleManagementComponent.module.scss";

interface ISearchableRolesListProps {
    roles: RoleHeaderModel[];
    onRoleClick: (clickedRoleId: string) => void;
    onCreateButtonClick: () => void;
    selectedRoleId: string | null;
    hideSelectionMarker?: boolean;
}

function SearchableRolesList(props: Readonly<ISearchableRolesListProps>): JSX.Element {
    const [searchText, setSearchText] = useState<string>("");

    const handleCreateRoleClick = (e: React.MouseEvent): void => {
        e.stopPropagation();
        props.onCreateButtonClick();
    };

    const filteredRoles = props.roles
        .filter(role => role.Name.contains(searchText, { ignoreCase: true, ignoreDiacritics: true }))
        .sortByProperty(role => role.Name.toUpperCase());

    return (
        <div className="fxheight transition full-border admin-users-search">
            <div className="user-search">
                <div className="search-field">
                    <div className="gf">
                        <span className="glyphicon glyphicon-search" />
                    </div>
                    <div style={{ width: "100%" }}>
                        <TextboxControl
                            onMountFocus
                            debounceMs={400}
                            value=""
                            name="text_search_users"
                            className="fullWidth"
                            placeholder={cacheStore.GetString("SearchLabel")}
                            autoComplete="off"
                            onChange={value => setSearchText(value)}
                            dataCy="sidebarRoleSearch"
                        />
                    </div>
                </div>

                <button className={styles.createRoleButton} data-cy="createRoleButton" onClick={(event: React.MouseEvent) => handleCreateRoleClick(event)}>
                    [+] {cacheStore.GetString("RoleBasedAccessControl_AddRoleLabel")}
                </button>
            </div>

            <div className="user-search-results scrollable">
                {filteredRoles.map((role: RoleHeaderModel, index: number) => {
                    const isInRole = (role.Id === props.selectedRoleId) ? " selected" : "";
                    const selectedRowMarkerClass: "" | " selected" = !props.hideSelectionMarker
                        ? isInRole
                        : "";

                    return (
                        <div
                            role="button"
                            tabIndex={index}
                            className={`roleHeader user-search-item pointer${selectedRowMarkerClass}`}
                            id={role.Name}
                            onFocus={() => null}
                            onClick={() => props.onRoleClick(role.Id)}
                            key={role.Id}
                            data-cy={`roleHeader${role.Id}`}
                        >
                            <strong>{role.Name}</strong>
                            <div>{role.UserCount} User(s)</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export { ISearchableRolesListProps, SearchableRolesList };
